import { SxProps, Theme } from '@mui/material/styles'

const BRAND_BLUE = '#1B4AA0'

export const scanSearchPanelStyles = {
  // ── Hint label ────────────────────────────────────────────────────────────

  hintLabel: {
    whiteSpace: 'nowrap',
    fontSize: '1rem',
    textAlign: 'left',
    width: '100%',
    pb: '4px'
  } as SxProps<Theme>,

  // ── Card container ────────────────────────────────────────────────────────

  card: {
    bgcolor: 'background.paper',
    border: '0.5px solid',
    borderColor: 'divider',
    borderRadius: 2,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 1.75
  } as SxProps<Theme>,

  // ── Toggle switch ─────────────────────────────────────────────────────────

  toggleGroup: {
    position: 'relative',
    display: 'flex',
    bgcolor: 'action.hover',
    borderRadius: '999px',
    p: '3px',
    gap: '2px'
  } as SxProps<Theme>,

  toggleSlider: (left: number, width: number) =>
    ({
      position: 'absolute',
      top: '3px',
      height: 'calc(100% - 6px)',
      left,
      width,
      bgcolor: BRAND_BLUE,
      borderRadius: '999px',
      transition:
        'left 0.25s cubic-bezier(.4,0,.2,1), width 0.25s cubic-bezier(.4,0,.2,1)',
      zIndex: 0,
      pointerEvents: 'none'
    }) as SxProps<Theme>,

  toggleBtn: (isActive: boolean) =>
    ({
      flex: 1,
      border: 'none',
      background: 'transparent',
      borderRadius: '999px',
      py: '8px',
      px: '12px',
      fontSize: '13px',
      fontWeight: isActive ? 500 : 400,
      color: isActive ? '#fff' : 'text.secondary',
      cursor: 'pointer',
      transition: 'color 0.2s ease',
      position: 'relative',
      zIndex: 1,
      whiteSpace: 'nowrap',
      '&:disabled': { opacity: 0.5, cursor: 'not-allowed' }
    }) as SxProps<Theme>,

  // ── Text input ────────────────────────────────────────────────────────────

  inputRoot: {
    borderRadius: 1,
    fontSize: '14px',
    '& fieldset': { borderColor: 'divider' },
    '&:hover fieldset': { borderColor: 'text.secondary' },
    '&.Mui-focused fieldset': { borderColor: BRAND_BLUE, borderWidth: '1.5px' }
  } as SxProps<Theme>,

  inputProps: {
    py: '10px'
  } as SxProps<Theme>
}
